import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const qk = {
  session: ["session"],
  dashboard: ["dashboard"],
  deliveries: (params) => ["deliveries", params || {}],
  delivery: (id) => ["delivery", id],
  billing: (id) => ["billing", id],
  plan: (offset, weeks) => ["plan", offset, weeks],
  service: (status) => ["service", status || "alle"],
  serviceCase: (id) => ["serviceCase", id],
  customers: ["customers"],
  customer: (id) => ["customer", id],
  installerJobs: ["installerJobs"],
  installerJob: (id) => ["installerJob", id],
  share: (token) => ["share", token],
  meta: ["meta"],
};

const get = (url, params) => async () => (await api.get(url, { params })).data;

export const useDashboard = () => useQuery({ queryKey: qk.dashboard, queryFn: get("/dashboard"), staleTime: 10_000 });
export const useDeliveries = (params) => useQuery({ queryKey: qk.deliveries(params), queryFn: get("/deliveries", params), staleTime: 10_000 });
export const useDelivery = (id) => useQuery({ queryKey: qk.delivery(id), queryFn: get(`/deliveries/${id}`), enabled: !!id, staleTime: 5_000 });
export const useBilling = (id) => useQuery({ queryKey: qk.billing(id), queryFn: get(`/deliveries/${id}/billing`), enabled: !!id });
export const usePlan = (offset = -1, weeks = 8) => useQuery({ queryKey: qk.plan(offset, weeks), queryFn: get("/plan", { offset, weeks }) });
export const useServiceCases = (status) => useQuery({ queryKey: qk.service(status), queryFn: get("/service", status ? { status } : undefined) });
export const useServiceCase = (id) => useQuery({ queryKey: qk.serviceCase(id), queryFn: get(`/service/${id}`), enabled: !!id });
export const useCustomers = () => useQuery({ queryKey: qk.customers, queryFn: get("/customers") });
export const useCustomer = (id) => useQuery({ queryKey: qk.customer(id), queryFn: get(`/customers/${id}`), enabled: !!id });
export const useInstallerJobs = () => useQuery({ queryKey: qk.installerJobs, queryFn: get("/installer/jobs") });
export const useInstallerJob = (id) => useQuery({ queryKey: qk.installerJob(id), queryFn: get(`/installer/jobs/${id}`), enabled: !!id });
export const useMeta = () => useQuery({ queryKey: qk.meta, queryFn: get("/meta"), staleTime: 300_000 });
export const useSession = () => useQuery({ queryKey: qk.session, queryFn: get("/session") });

/** After a delivery mutation: put the fresh detail into cache and invalidate lists. */
export function useDeliveryUpdater() {
  const qc = useQueryClient();
  return (detail) => {
    if (detail?.id) qc.setQueryData(qk.delivery(detail.id), detail);
    qc.invalidateQueries({ queryKey: ["deliveries"] });
    qc.invalidateQueries({ queryKey: qk.dashboard });
    qc.invalidateQueries({ queryKey: ["plan"] });
    qc.invalidateQueries({ queryKey: ["service"] });
    qc.invalidateQueries({ queryKey: ["billing"] });
    qc.invalidateQueries({ queryKey: ["installerJobs"] });
    qc.invalidateQueries({ queryKey: ["customer"] });
    qc.invalidateQueries({ queryKey: qk.session });
  };
}
